module.exports = __webpack_public_path__ + "static/media/accessoriesIcon.6f4ecdec.svg";